import { provideMockStore } from '@ngrx/store/testing';
import { all } from 'deepmerge';

export function provideMockStoreAndMergeStates(...states: any[]) {
  return provideMockStore({
    initialState: all(states)
  });
}
